import React from 'react';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../Utils/Constants';

const ActiveJobs = ({ jobs = [] }) => {
  return (
    <div className="white-wraper extra-mt mob-margin">
      <h2 className="add-margin">Active Jobs ({new Date().toLocaleString('default', { month: 'long' })} {new Date().getFullYear() })</h2>
      <div className="chart-canvas2 ajtable-canvas">
        <div className="aj-table">
          <table className="table" id="activejobs-table">
            <thead>
              <tr>
                <th className='aj-col1'>Job ID</th>
                <th className='aj-col2'>Description</th>
                <th className='aj-col3'>Type</th>
                <th className='aj-col4'>Location</th>
                <th className='aj-col5'>Start Time</th>
              </tr>
            </thead>
            <tbody>
              {jobs.length > 0 ? (
                jobs.map((job, idx) => (
                  <tr key={idx}>
                    <td>{job.job_name}</td>
                    <td>{job.job_description || '-'}</td>
                    <td>{job.job_type}</td>
                    <td>{job.start_location || '-'}</td>
                    <td>{moment.utc(job.start_date_time).local().format(DATE_TIME_FORMAT)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-secondary border-none" style={{ paddingTop: "4rem", paddingBottom: "3rem" }}>No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ActiveJobs;